import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import EditorialPolicyScreen from './EditorialPolicyScreen'

const EndUserEditorialPolicyRoutes = () => {
  return (
    <Routes>
        {/*<Route path="/" element={<PrivateRoute7><DashboardUserScreen /></PrivateRoute7>}></Route>*/}
        <Route path="/" element={<PrivateRoute7><EditorialPolicyScreen /></PrivateRoute7>} />
        
    </Routes>
  )
}

export default EndUserEditorialPolicyRoutes